
var activityProgressBar = ( function ( $, activityProgressBar ) {
    'use strict';

    activityProgressBar.interval = null;
    activityProgressBar.isDropdownOpen = false;

    activityProgressBar.render = function(loadActivities) {
        $.ajax({
            url: '/admin/user/activity-progress-bar',
            data: {
                'loadActivities': loadActivities
            },
            success: function(response) {
                $('[data-activity-progress-bar-content]').html(response.html);

                // pokud se vrátí null, tak nejsou žádné aktivity, tak ukončíme interval
                if (!response.html) {
                    clearInterval(activityProgressBar.interval);
                }

                if (activityProgressBar.isDropdownOpen) {
                    $('[data-activity-progress-bar-content] .dropdown:not(.show) [data-toggle="dropdown"]').click();
                }

            }
        });
    };

    activityProgressBar.initialize = function()
    {
        activityProgressBar.render(1);

        activityProgressBar.interval = setInterval(function() {
            activityProgressBar.render(0);
        }, 5000);

        let $content = $('[data-activity-progress-bar-content]');

        $content.delegate('#activity-progress-dropdown', 'hide.bs.dropdown', function() {
            activityProgressBar.isDropdownOpen = false;
        });

        $content.delegate('#activity-progress-dropdown', 'show.bs.dropdown', function() {
            activityProgressBar.isDropdownOpen = true;
        });
    };

    return activityProgressBar;

}( window.jQuery, activityProgressBar || { } ) );

window.activityProgressBar = activityProgressBar;


